import { ChannelDictionary, SearchCriteria, GenreWithValue, ScheduleDictionary, NewsArticlePackage } from "core/types";
import { action, computed, makeObservable, observable } from "mobx";

import { LayoutType } from "core/constants";
import context from "core/tv-guide.context";
import dateTimeWrapper from "core/lib/date-time-wrapper";

export type DateTime = {
    date: string;
    hours: number;
    minutes: number
}

class TvGuideStore {
    dates: Date[] = [];
    genres: GenreWithValue[] = [];
    packages: string[] = [];
    channels: ChannelDictionary = {};
    channelNumbers: number[] = [];
    dateOption = "1";//number of days to show in list view

    searchCriteria: SearchCriteria = {}
    schedule: ScheduleDictionary = {};
    scheduleDates: Date[] = [];
    hasBasicData = false;
    hasScheduleData = false;

    newsArticles: NewsArticlePackage[] = [];
    currentTime = "";
    dateTime: DateTime = { date: "", hours: 0, minutes: 0 };

    favouriteChannelNumbers: number[] = [];

    layout = LayoutType.grid;

    showFavourites = false;

    currentChannel = 0;

    isFetching = false;

    constructor() {
        this.favouriteChannelNumbers = context.storage.favourites ?? [];
        this.layout = context.storage.layout ?? LayoutType.grid;

        this.updateCurrentTime();

        makeObservable(this, {
            dates: observable,
            genres: observable,
            packages: observable,
            channels: observable,
            channelNumbers: observable,
            layout: observable,
            currentChannel: observable,
            isFetching: observable,
            dateTime: observable,
            currentTime: observable,
            dateOption: observable,

            favouriteChannelNumbers: observable,
            searchCriteria: observable,
            schedule: observable,
            scheduleDates: observable,
            showFavourites: observable,
            newsArticles: observable,

            updateChannels: action,
            updateChannelNumbers: action,
            updateCurrentChannel: action,
            updateDates: action,
            updateGenres: action,
            updatePackages: action,
            updateSchedule: action,
            updateScheduleDates: action,
            updateSearchCriteria: action,
            updateIsFetching: action,
            updateFavouriteChannelNumbers: action,
            updateCurrentTime: action,
            updateNewsArticles: action,
            updateDateOption: action,

            hasFavourites: computed,

            hasBasicData: observable,
            hasScheduleData: observable,
            updateHasScheduleData: action
        });
    }

    updateDates(value: Date[]) {
        this.dates = value;
    }

    updateGenres(value: GenreWithValue[]) {
        this.genres = value;
    }

    updatePackages(value: string[]) {
        this.packages = value;
    }

    updateChannels(value: ChannelDictionary) {
        this.channels = value;
    }

    updateChannelNumbers(value: number[]) {
        this.channelNumbers = value;
    }

    updateSearchCriteria(value: SearchCriteria) {
        this.searchCriteria = value;
    }

    updateSchedule(value: ScheduleDictionary) {
        this.schedule = value;
    }

    updateScheduleDates(value: Date[]) {
        this.scheduleDates = value;
    }

    updateFavouriteChannelNumbers(value: number[]) {
        this.favouriteChannelNumbers = value;

        context.storage.updateFavourites(value);
    }

    updateShowFavourites(value: boolean) {
        this.showFavourites = value;
    }

    get hasFavourites() {
        return this.favouriteChannelNumbers.length > 0;
    }

    updateCurrentChannel(value: number) {
        this.currentChannel = value;
    }

    updateIsFetching(value: boolean) {
        this.isFetching = value;
    }

    updateCurrentTime() {
        const { date, time } = dateTimeWrapper();

        const [hours, minutes] = time.split(":").map(x => parseInt(x));

        this.dateTime = {
            date,
            hours,
            minutes
        };
    }

    updateDateOption(value: string) {
        this.dateOption = value;
    }
    // get hasData(): boolean {
    //     if (!this.genres.length) {
    //         return false;
    //     }

    //     if (!this.channelNumbers.length) {
    //         return false;
    //     }

    //     if (!this._hasSchedule || !this._hasChannels) {
    //         return false;
    //     }

    //     return true;
    // }

    updateHasBasicData(value: boolean) {
        this.hasBasicData = value;
        console.debug(`Has Basic Data: ${value}`);
    }

    updateHasScheduleData(value: boolean) {
        this.hasScheduleData = value;
        console.debug(`Has Schedule Data: ${value}`);
    }

    updateLayout(value: string) {
        this.layout = value;

        context.storage.updateLayout(value);
    }

    updateNewsArticles(value: NewsArticlePackage[]) {
        this.newsArticles = value;
    }
}

export default TvGuideStore;